import { Button, Divider, Form, Space, Typography } from "antd";

import { PhoneOtpRequest } from "@/types";

import { GoogleLoginButton } from "./GoogleLoginButton";
import { PhoneFormItem } from "./PhoneFormItem";

const { Text } = Typography;

interface PhoneOtpLoginFormProps {
  googleDisabled?: boolean;
  isGoogleSubmitting?: boolean;
  isSubmitting?: boolean;
  onGoogleLogin: () => void;
  onSubmit: (payload: PhoneOtpRequest) => void;
  onUsePassword: () => void;
  phoneLabel?: string;
  submitText?: string;
}

export const PhoneOtpLoginForm = ({
  googleDisabled = false,
  isGoogleSubmitting = false,
  isSubmitting = false,
  onGoogleLogin,
  onSubmit,
  onUsePassword,
  phoneLabel = "Số điện thoại",
  submitText = "Gửi mã OTP",
}: PhoneOtpLoginFormProps) => (
  <Form<PhoneOtpRequest>
    layout="vertical"
    onFinish={(values) => {
      onSubmit(values);
    }}
  >
    <PhoneFormItem autoFocus label={phoneLabel} />

    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <Button block htmlType="submit" loading={isSubmitting} type="primary">
        {submitText}
      </Button>

      <Divider plain>
        <Text type="secondary">Hoặc</Text>
      </Divider>

      <GoogleLoginButton
        disabled={googleDisabled}
        loading={isGoogleSubmitting}
        onClick={onGoogleLogin}
      />

      <Button block onClick={onUsePassword}>
        Đăng nhập bằng tài khoản và mật khẩu
      </Button>
    </Space>
  </Form>
);
